export const WEB_APP = "/webapp";
export const DISPLAY = "/displayartists";